import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    userId: String,
    salaryCalculationId: String,
    month: String,
    year: String,
    url: String
  }

  connect() {
    this.poll()
  }

  disconnect() {
    this.stopPolling()
  }

  poll() {
    this.pollInterval = setInterval(() => {
      this.fetchUpdate()
    }, 2000) // Poll every 2 seconds
  }

  stopPolling() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
    }
  }

  async fetchUpdate() {
    // Stop polling if element is no longer in the document
    if (!this.element.isConnected) {
      this.stopPolling()
      return
    }

    const params = new URLSearchParams({
      user_id: this.userIdValue,
      salary_calculation_id: this.salaryCalculationIdValue,
      month: this.monthValue,
      year: this.yearValue
    })

    try {
      const response = await fetch(`${this.urlValue}?${params}`, {
        headers: {
          "Accept": "text/vnd.turbo-stream.html"
        }
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
        
        // Check if this element still exists after rendering (it might have been replaced)
        setTimeout(() => {
          if (!this.element.isConnected) {
            this.stopPolling()
          }
        }, 100)
      }
    } catch (error) {
      console.error("Polling error:", error)
      this.stopPolling()
    }
  }
}

